import { BookingType } from "./booking-inputs";

export type AffectedExistingBookingAction = "cancel" | "shorten";

export type AffectedExistingBooking = {
  id: number;
  start: string;
  end: string;
  bookingType: BookingType;
  label?: string;
  action: AffectedExistingBookingAction;
};

export type CancelExistingConfirmationResponse = {
  requiresCancelExistingConfirmation: true;
  affectedBookings: AffectedExistingBooking[];
};

export function isCancelExistingConfirmationResponse(
  data: unknown
): data is CancelExistingConfirmationResponse {
  return (
    typeof data === "object" &&
    data !== null &&
    (data as CancelExistingConfirmationResponse).requiresCancelExistingConfirmation === true &&
    Array.isArray((data as CancelExistingConfirmationResponse).affectedBookings)
  );
}
